import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import 'bootstrap/scss/bootstrap.scss';
import 'bootstrap-icons/font/bootstrap-icons.scss';

// FONTOS: a bundle-t importáld, ebben benne van a Popper is
import * as bootstrap from 'bootstrap/dist/js/bootstrap.bundle';

// (opcionális) ha kell neked globálisan is:
(window as any).bootstrap = bootstrap;

function ready(fn: () => void) {
  if (document.readyState !== 'loading') fn();
  else document.addEventListener('DOMContentLoaded', fn);
}

ready(() => {
  // Smooth scroll
  document.querySelectorAll('[href^="#"]').forEach(link => {
    link.addEventListener('click', e => {
      const targetId = (e.currentTarget as HTMLAnchorElement).getAttribute('href')!;
      if (targetId.startsWith('#') && targetId.length > 1) {
        const el = document.querySelector(targetId);
        if (el) {
          e.preventDefault();
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });
  });

  // Navbar shadow on scroll
  const nav = document.querySelector('.main-navbar');
  const onScroll = () => {
    if (!nav) return;
    (window.scrollY > 8) ? nav.classList.add('shadow-sm') : nav.classList.remove('shadow-sm');
  };
  window.addEventListener('scroll', onScroll); onScroll();

  // Booking modal
  const bookingModalEl = document.getElementById('bookingModal');
  const bookingModal = bookingModalEl ? new (window as any).bootstrap.Modal(bookingModalEl) : null;

  document.querySelectorAll('[data-action="open-booking"]').forEach(btn => {
    btn.addEventListener('click', (e) => {
      const hash = (e.currentTarget as HTMLAnchorElement).getAttribute('href') || '';
      if (hash?.startsWith('#')) e.preventDefault();
      bookingModal?.show();
    });
  });

  // Call now tracking (stub)
  document.querySelectorAll('[data-action="call-now"]').forEach(a => {
    a.addEventListener('click', () => console.log('Call now clicked'));
  });

});

document.addEventListener("DOMContentLoaded", () => {
  const sections = document.querySelectorAll("section");
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible");
          observer.unobserve(entry.target); // egyszer animáljon
        }
      });
    },
    { threshold: 0.15 } // kb. 15%-nál indul
  );

  sections.forEach((sec) => {
    sec.classList.add("section-fade");
    observer.observe(sec);
  });
});

(() => {
  const el = document.getElementById('doctorsCarousel');
  if (!el) return;

  const inner = el.querySelector('.carousel-inner');

  const itemsPerSlide = () => (window.innerWidth >= 992 ? 4 : 2);

  const rebuildClones = () => {
    const perSlide = itemsPerSlide();
    const items = Array.from(inner.querySelectorAll('.carousel-item'));

    // Takarítsuk a régi klónokat
    items.forEach(item => {
      const wrap = item.querySelector('.doctor-slide-inner');
      if (!wrap) return;
      wrap.querySelectorAll('.doctor-clone.clone').forEach(n => n.remove());
      wrap.classList.add('doctor-slide-inner');
    });

    // Újraépítés
    items.forEach((item, i) => {
      const wrap = item.querySelector('.doctor-slide-inner');
      if (!wrap) return;

      // Az első elem legyen "base"
      let base = wrap.querySelector('.doctor-clone.base');
      if (!base) {
        const a = wrap.firstElementChild;
        if (!a) return;
        base = document.createElement('div');
        base.className = 'doctor-clone base';
        base.appendChild(a);
        wrap.appendChild(base);
      }

      // Klónozzuk a következő elemeket
      for (let k = 1; k < perSlide; k++) {
        const nextIndex = (i + k) % items.length;
        const nextItem = items[nextIndex];
        const nextLink = nextItem.querySelector('.doctor-slide-inner a');
        if (!nextLink) continue;

        const clone = document.createElement('div');
        clone.className = 'doctor-clone clone';
        clone.appendChild(nextLink.cloneNode(true));
        wrap.appendChild(clone);
      }
    });
  };

  // base osztályozás első futásra
  Array.from(inner.querySelectorAll('.carousel-item')).forEach(item => {
    const wrap = item.querySelector('.doctor-slide-inner');
    const a = wrap?.firstElementChild;
    if (!a) return;
    const base = document.createElement('div');
    base.className = 'doctor-clone base';
    base.appendChild(a);
    wrap.appendChild(base);
  });

  rebuildClones();

  // Autoplay (BS5 native)
  const carousel = new bootstrap.Carousel(el, {
    interval: parseInt(el.getAttribute('data-bs-interval') || '4000', 10),
    ride: 'carousel',
    wrap: true,
    touch: true,
    pause: false
  });

  // Resize-re klónok újraépítése, hogy 2/4-es nézet maradjon
  let resizeT;
  window.addEventListener('resize', () => {
    clearTimeout(resizeT);
    resizeT = setTimeout(() => {
      rebuildClones();
      carousel.to(carousel._getActiveIndex()); // maradjon ugyanott
    }, 150);
  });
})();

(() => {
  const LS_KEY = "cookieConsent.v2";
  const DEFAULT = { necessary: true, stats: false, marketing: false };

  // ---- dataLayer + gtag biztosítása ----
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function(){ dataLayer.push(arguments); };

  // Consent Mode: alapértelmezés (nem szükséges tárolások tiltva)
  gtag('consent', 'default', {
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    analytics_storage: 'denied',
    functionality_storage: 'granted',
    security_storage: 'granted'
  });

  // ---- segédek ----
  const save = (prefs) => localStorage.setItem(LS_KEY, JSON.stringify(prefs));
  const load = () => {
    try { return JSON.parse(localStorage.getItem(LS_KEY)); } catch(_) { return null; }
  };
  const applyToGtag = (prefs, mode='update') => {
    const payload = {
      analytics_storage: prefs.stats ? 'granted' : 'denied',
      ad_storage: prefs.marketing ? 'granted' : 'denied',
      ad_user_data: prefs.marketing ? 'granted' : 'denied',
      ad_personalization: prefs.marketing ? 'granted' : 'denied',
      functionality_storage: 'granted',
      security_storage: 'granted'
    };
    gtag('consent', mode, payload);
    window.dataLayer.push({ event: 'cookie_consent_update', consent: { necessary: true, stats: !!prefs.stats, marketing: !!prefs.marketing }});
  };

  // kezdeti állapot
  const existing = load();
  if (existing) applyToGtag(existing, 'update');

  // ---- Stílus ----
  const css = `
.ccc-backdrop{position:fixed;inset:0;background:rgba(0,0,0,.4);display:none;z-index:99998}
.ccc-banner{position:fixed;left:0;right:0;bottom:0;z-index:99999;font-family:system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif;display:none}
.ccc-card{margin:16px auto;max-width:960px;background:#fff;border-radius:12px;box-shadow:0 10px 30px rgba(0,0,0,.15);overflow:hidden}
.ccc-body{padding:16px}
.ccc-title{font-weight:700;font-size:16px;margin:0 0 8px}
.ccc-text{font-size:14px;line-height:1.5;margin:0 0 12px;color:#222}
.ccc-actions{display:flex;gap:8px;flex-wrap:wrap;justify-content:flex-end;padding:12px 16px;background:#f6f6f6;border-top:1px solid #eee}
.ccc-btn{appearance:none;border:0;border-radius:999px;padding:10px 14px;font-weight:600;font-size:14px;cursor:pointer}
.ccc-btn-primary{background:#0b57d0;color:#fff}
.ccc-btn-secondary{background:#e9eef9;color:#0b57d0}
.ccc-btn-ghost{background:#fff;border:1px solid #ddd;color:#111}
.ccc-link{background:none;border:0;color:#0b57d0;text-decoration:underline;cursor:pointer;font-size:14px;padding:0 4px}
.ccc-modal{position:fixed;inset:0;display:none;align-items:center;justify-content:center;z-index:100000}
.ccc-modal .ccc-dialog{width:min(720px,92vw);background:#fff;border-radius:14px;box-shadow:0 12px 40px rgba(0,0,0,.25);max-height:86vh;display:flex;flex-direction:column}
.ccc-modal .ccc-head{padding:16px 20px;border-bottom:1px solid #eee;display:flex;justify-content:space-between;align-items:center}
.ccc-modal .ccc-head h3{margin:0;font-size:18px}
.ccc-modal .ccc-content{padding:16px 20px;overflow:auto}
.ccc-toggle{display:flex;align-items:center;justify-content:space-between;border:1px solid #eee;border-radius:12px;padding:12px 14px;margin:10px 0}
.ccc-toggle h4{margin:0;font-size:15px}
.ccc-toggle p{margin:6px 0 0;font-size:13px;color:#444;max-width:60ch}
.ccc-switch{position:relative;width:46px;height:26px;flex:0 0 auto}
.ccc-switch input{opacity:0;width:0;height:0}
.ccc-slider{position:absolute;inset:0;background:#ddd;border-radius:999px;transition:.2s}
.ccc-slider:before{content:"";position:absolute;height:20px;width:20px;left:3px;top:3px;background:#fff;border-radius:50%;transition:.2s;box-shadow:0 1px 2px rgba(0,0,0,.2)}
.ccc-switch input:checked + .ccc-slider{background:#0b57d0}
.ccc-switch input:checked + .ccc-slider:before{transform:translateX(20px)}
.ccc-badge{font-size:11px;font-weight:700;background:#eef5ff;color:#0b57d0;border:1px solid #d5e3ff;border-radius:6px;padding:2px 6px;margin-left:6px}
.ccc-badge.lock{background:#eee;color:#666;border-color:#ddd}

/* Lebegő “süti” gomb — csak desktopon */
.ccc-fab{position:fixed;right:16px;bottom:16px;z-index:100001;display:none;align-items:center;justify-content:center;width:52px;height:52px;border-radius:50%;background:#0b57d0;box-shadow:0 10px 24px rgba(0,0,0,.25)}
.ccc-fab button{all:unset;display:flex;align-items:center;justify-content:center;width:100%;height:100%;cursor:pointer}
.ccc-fab svg{width:26px;height:26px;fill:#fff}
@media (min-width: 768px){ .ccc-fab{display:flex} }

@media (prefers-color-scheme: dark){
  .ccc-card,.ccc-modal .ccc-dialog{background:#1f1f1f;color:#eee}
  .ccc-text{color:#e6e6e6}
  .ccc-actions{background:#171717;border-color:#333}
  .ccc-btn-ghost{background:#1f1f1f;border-color:#333;color:#eee}
  .ccc-toggle{border-color:#333}
  .ccc-badge{background:#112b57;color:#cfe0ff;border-color:#1f3c75}
  .ccc-badge.lock{background:#2a2a2a;color:#aaa;border-color:#333}
  .ccc-slider{background:#444}
}
  `;

  // ---- HTML ----
  const html = `
<div class="ccc-banner" role="region" aria-label="Süti hozzájárulás" data-ccc="banner">
  <div class="ccc-card" role="dialog" aria-live="polite">
    <div class="ccc-body">
      <p class="ccc-title">Sütik kezelése</p>
      <p class="ccc-text">A működéshez szükséges sütiket használjuk az oldal alapvető funkcióihoz. A <strong>Statisztika</strong> és <strong>Marketing</strong> sütikhez a hozzájárulásodra van szükség.</p>
      <button class="ccc-link" type="button" data-ccc="open-settings" aria-haspopup="dialog" aria-controls="ccc-modal">Beállítások</button>
    </div>
    <div class="ccc-actions">
      <button class="ccc-btn ccc-btn-ghost" type="button" data-ccc="reject-all">Elutasítom</button>
      <button class="ccc-btn ccc-btn-secondary" type="button" data-ccc="accept-needed">Csak szükséges</button>
      <button class="ccc-btn ccc-btn-primary" type="button" data-ccc="accept-all">Elfogadok mindent</button>
    </div>
  </div>
</div>
<div class="ccc-backdrop" data-ccc="backdrop"></div>

<div class="ccc-modal" id="ccc-modal" role="dialog" aria-modal="true" aria-labelledby="ccc-title">
  <div class="ccc-dialog">
    <div class="ccc-head">
      <h3 id="ccc-title">Sütik beállításai</h3>
      <button class="ccc-btn ccc-btn-ghost" type="button" data-ccc="close-settings" aria-label="Bezárás">✕</button>
    </div>
    <div class="ccc-content">
      <div class="ccc-toggle">
        <div>
          <h4>Működéshez szükséges <span class="ccc-badge lock">mindig aktív</span></h4>
          <p>Ezek a sütik az oldal alapvető működéséhez kellenek (biztonság, bejelentkezés, kosár).</p>
        </div>
        <label class="ccc-switch" aria-label="Szükséges sütik"><input type="checkbox" checked disabled><span class="ccc-slider"></span></label>
      </div>
      <div class="ccc-toggle">
        <div>
          <h4>Statisztika <span class="ccc-badge">GA4</span></h4>
          <p>Névtelen mérések és aggregált statisztika a jobb élményért.</p>
        </div>
        <label class="ccc-switch" aria-label="Statisztika kapcsoló">
          <input type="checkbox" data-ccc="toggle-stats"><span class="ccc-slider"></span>
        </label>
      </div>
      <div class="ccc-toggle">
        <div>
          <h4>Marketing <span class="ccc-badge">Ads</span></h4>
          <p>Hirdetések mérése, személyre szabása és hirdetési felhasználói adatok kezelése.</p>
        </div>
        <label class="ccc-switch" aria-label="Marketing kapcsoló">
          <input type="checkbox" data-ccc="toggle-marketing"><span class="ccc-slider"></span>
        </label>
      </div>
    </div>
    <div class="ccc-actions">
      <button class="ccc-btn ccc-btn-ghost" type="button" data-ccc="close-settings">Mégse</button>
      <button class="ccc-btn ccc-btn-secondary" type="button" data-ccc="only-necessary">Csak szükséges</button>
      <button class="ccc-btn ccc-btn-primary" type="button" data-ccc="save-settings">Beállítások mentése</button>
    </div>
  </div>
</div>

<!-- Lebegő “süti” gomb (csak desktopon látszik) -->
<div class="ccc-fab" data-ccc="fab" aria-hidden="true" title="Sütik beállításai">
  <button type="button" data-ccc="open-settings" aria-label="Sütik beállításai">
    <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M19.5 11.5a3.5 3.5 0 0 1-3.5-3.5 4 4 0 0 1-4-4 7.5 7.5 0 1 0 7.5 7.5zM8 14.25a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5Zm2.75 4a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5ZM15 12a1.25 1.25 0 1 1 0-2.5A1.25 1.25 0 0 1 15 12Z"/></svg>
  </button>
</div>
  `;

  // injektálás
  const style = document.createElement('style');
  style.setAttribute('data-ccc', 'style');
  style.textContent = css;
  document.head.appendChild(style);

  const wrap = document.createElement('div');
  wrap.setAttribute('id','ccc-root');
  wrap.innerHTML = html;
  document.body.appendChild(wrap);

  // elemek
  const $ = (sel) => wrap.querySelector(sel);
  const banner = $('[data-ccc="banner"]');
  const modal = $('#ccc-modal');
  const backdrop = $('[data-ccc="backdrop"]');
  const fab = $('[data-ccc="fab"]');
  const chkStats = $('[data-ccc="toggle-stats"]');
  const chkMkt = $('[data-ccc="toggle-marketing"]');

  // állapot -> UI
  const setTogglesFrom = (prefs) => {
    chkStats.checked = !!prefs.stats;
    chkMkt.checked = !!prefs.marketing;
  };

  const current = existing || DEFAULT;
  setTogglesFrom(current);

  // banner csak akkor, ha nincs még döntés
  if (!existing) banner.style.display = 'block';
  // lebegő gomb csak akkor aktív, ha már volt döntés
  const setFabVisibility = () => {
    if (load()) {
      fab.setAttribute('aria-hidden','false');
    } else {
      fab.setAttribute('aria-hidden','true');
    }
  };
  setFabVisibility();

  // modal nyit/zár
  const openModal = () => {
    const prefs = load() || DEFAULT;
    setTogglesFrom(prefs);
    modal.style.display='flex'; backdrop.style.display='block';
  };
  const closeModal = () => { modal.style.display='none'; backdrop.style.display='none'; };

  // click handler
  wrap.addEventListener('click', (e) => {
    const target = e.target.closest('[data-ccc]');
    if (!target) return;
    const action = target.getAttribute('data-ccc');

    if (action === 'open-settings') openModal();
    if (action === 'close-settings') closeModal();

    if (action === 'accept-all') {
      const prefs = { necessary:true, stats:true, marketing:true, ts: Date.now() };
      save(prefs); applyToGtag(prefs);
      banner.style.display='none'; closeModal(); setFabVisibility();
    }

    if (action === 'reject-all' || action === 'only-necessary' || action === 'accept-needed') {
      const prefs = { necessary:true, stats:false, marketing:false, ts: Date.now() };
      save(prefs); applyToGtag(prefs);
      banner.style.display='none'; closeModal(); setFabVisibility();
    }

    if (action === 'save-settings') {
      const prefs = { necessary:true, stats:!!chkStats.checked, marketing:!!chkMkt.checked, ts: Date.now() };
      save(prefs); applyToGtag(prefs);
      closeModal(); setFabVisibility();
    }

    if (action === 'backdrop') closeModal();
  });

  // ESC zárás
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeModal(); });

  // kicsi publikus API
  window.CookieConsent = {
    open: openModal,
    reset: () => { localStorage.removeItem(LS_KEY); location.reload(); },
    get: () => load(),
    set: (prefs) => {
      const merged = { necessary:true, stats:!!prefs.stats, marketing:!!prefs.marketing, ts: Date.now() };
      save(merged); applyToGtag(merged); setFabVisibility();
    }
  };
})();
